var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 mb-1"},[_c('h4',{staticClass:"mb-1 table-title"},[_vm._v("Company PL")]),_c('StatisticCards')],1)}
var staticRenderFns = []

export { render, staticRenderFns }